import React from "react";
import { painPoints } from "../../data/content";
import { CtaButton } from "../CtaButton";
export function PainPoints() {
  return <section className="bg-navy-deep py-16 text-white sm:py-20" aria-labelledby="pain-title" data-id="element-225" data-mp="1twgy0yfp2mct">
      <div className="mx-auto max-w-3xl px-5" data-id="element-226" data-mp="27nvf2zq1kdh8">
        <p className="text-center text-sm font-bold uppercase tracking-wider text-sky" data-id="element-227" data-mp="22vu7hr3tjaxj">Let me ask you something…</p>
        <h2 id="pain-title" className="mt-4 text-center font-display text-[30px] font-black leading-tight sm:text-[42px]" data-id="element-228" data-mp="2hjypstyylkfs">
          Have you ever had a patient with a herniated disc sitting in front of you and thought:{" "}
          <em className="text-sky" data-id="element-229" data-mp="2qjvc4oxvm77o">“Where exactly should I start?”</em>
        </h2>

        <ul className="mt-10 divide-y divide-white/10 border-y border-white/10" data-id="element-230" data-mp="2mjbap969shfq">
          {painPoints.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex gap-4 py-5" data-id="element-231" data-mp="w7f4pktcgn18">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white/10 text-sky" data-id="element-232" data-mp="s6bupexz9l7x">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-233" data-mp="1n94na1qiuf0m" />
              </span>
              <p className="text-[16px] leading-relaxed text-white/85 sm:text-[17px]" data-id="element-234" data-mp="1s64sybjglfr7">{text}</p>
            </li>)}
        </ul>

        <div className="mt-10 text-center" data-id="element-235" data-mp="1x4ojkp8zzfpw">
          <p className="font-display text-[28px] font-black leading-tight sm:text-4xl" data-id="element-236" data-mp="21x7wrl3rw8u6">That's exactly why I created this.</p>
          <p className="mt-4 text-[17px] text-white/75" data-id="element-237" data-mp="26urcyqk16vor">You don't necessarily need more information.</p>
          <p className="mt-1 text-[19px] font-bold text-white" data-id="element-238" data-mp="2aw310rn9b8uu">You need a better way to organize the information you already have.</p>
        </div>

        <div className="mt-10" data-id="element-239" data-mp="2kvk5j5qrvgp8">
          <CtaButton label="Show me the system" tone="dark" caption="Instant access · 7-day guarantee" data-id="element-240" data-mp="2kvtzf4exu807" />
        </div>
      </div>
    </section>;
}